import { Sidebar, SidebarContent } from "@/components/ui/sidebar";
import { TripsList } from "@/features/trips/trips-list";
import { useSidebar } from "@/components/ui/sidebar";

export function DashboardSidebar() {
  const { state } = useSidebar();

  return (
    <Sidebar
      className="h-screen flex flex-col transition-all duration-300 ease-in-out"
      style={{
        width: state === "expanded" ? "380px" : "48px",
        minWidth: state === "expanded" ? "380px" : "48px",
      }}
      collapsible="icon"
    >
      <SidebarContent className="flex-1 overflow-hidden bg-gray-100">
        <div
          className={`${
            state === "collapsed" ? "opacity-0 w-0" : "opacity-100 w-full"
          } transition-all duration-200 h-full flex flex-col`}
        >
          <TripsList />
        </div>
      </SidebarContent>
    </Sidebar>
  );
}
